export class StripeAccountSessionResponse {
    public clientSecret: string = "";
}
